import { useNavigate, useOutletContext } from 'react-router-dom';
import { ProfileInfo, SignupError } from '../../components/signup';
import { ProfileInfoFormData, SignupOutletContext } from '../../components/signup/types';
import { Affiliation } from '../../types';
import { useFlowType } from '../../hooks/useFlowType';
import * as Sentry from '@sentry/react';

const ProfileInfoPage = () => {
  const navigate = useNavigate();
  const signupId = localStorage.getItem('signupId');
  const { formState, updateFormState } = useOutletContext<SignupOutletContext>();
  const flowType = useFlowType();

  const isDemoFlow = flowType === 'demo';

  const handleNext = (affiliation?: Affiliation) => {
    const basePath = `/${flowType}`;

    // If demo flow and user selected non-healthcare practice affiliation, skip to success page
    if (isDemoFlow && affiliation !== 'healthcare_practice') {
      navigate(`${basePath}/success`);
    } else {
      navigate(`${basePath}/practice-info`);
    }
  };

  const handleFormDataUpdate = (updates: Partial<ProfileInfoFormData>) => {
    updateFormState(updates);
  };

  if (!signupId) {
    Sentry.captureException('[ProfileInfoPage] Missing signup ID in form state');
    return <SignupError />;
  }

  return (
    <ProfileInfo
      onNext={handleNext}
      signupId={signupId}
      isDemoFlow={isDemoFlow}
      defaultValues={{
        first_name: formState.first_name || '',
        last_name: formState.last_name || '',
        contact_phone: formState.contact_phone || '',
        role: formState.role,
        affiliation: formState.affiliation,
        practice_name: formState.practice_name || '',
      }}
      onFormDataUpdate={handleFormDataUpdate}
      hubspotBaseData={formState}
    />
  );
};

export default ProfileInfoPage;
